module.exports = __webpack_public_path__ + "img/AL273LS-1-EN.7b3f0aed.jpg";